// ============================================
// Northworld — useAuth Hook
// ============================================
import { useEffect } from 'react'
import { useAuthStore } from '@/shared/store/authStore'

export function useAuth() {
  const { user, isLoading, error, setUser, setLoading, setError, reset } = useAuthStore()

  useEffect(() => {
    let cancelled = false

    async function fetchSession() {
      try {
        // cache:no-store → SW キャッシュを完全スキップ（セッションは常に最新を取得）
        const res = await fetch('/api/auth/get-session', {
          credentials: 'include',
          cache: 'no-store',
          headers: { 'Content-Type': 'application/json' },
        })
        if (cancelled) return
        if (!res.ok) { setUser(null); return }

        const data = await res.json()
        if (cancelled) return
        setUser(data?.user ?? null)
      } catch {
        if (!cancelled) setUser(null)
      }
    }

    fetchSession()
    return () => { cancelled = true }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const signOut = async () => {
    try {
      await fetch('/api/auth/sign-out', {
        method: 'POST',
        credentials: 'include',
        cache: 'no-store',
        headers: { 'Content-Type': 'application/json' },
        body: '{}',
      })
    } catch { /* ignore */ }
    reset()
  }

  return {
    user,
    isLoading,
    error,
    isAuthenticated: !!user,
    signOut,
  }
}
